var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginPageLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256.15,
    height: 76.379,
    viewBox: "0 0 256.15 76.379",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#81b830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#199b8b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#002f34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009b8b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.035,
    y1: 0.5,
    x2: 1.035,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11719",
    "data-name": "Group 11719",
    transform: "translate(-295.598 -903.306)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(431.599 922.74)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M295.6,1121.978h5.247v-27.654H295.6Zm10.016-27.654v4.7H313.6v22.954h5.247v-22.954h8.266v-4.7Zm66.79,4.072,4.781,14.4h-9.481Zm-4.011-4.072-9.2,27.654h5.551l1.722-5.308H378.4l1.762,5.308h5.449l-9.339-27.654Zm42.107,0v15.924l.04,3.565.061,1.783.06,1.783h-.182l-1.054-2.269-1.053-2.249q-1.256-2.654-2.208-4.518l-7.192-14.02h-8.894v27.654h5.247v-15.863l-.04-3.626-.061-1.8-.081-1.823h.2l.871,1.985.891,1.985q1.256,2.836,1.844,3.971l7.9,15.174h8.894v-27.654Zm-73.567,22.245q-1.085-1.155-1.084-7.232,0-8.043.891-9.4t6.179-1.358q4.437,0,5.693,1.084t1.256,4.953v6.22q0,.507-.162,2.006l-5.713-3.87-2.188,3.161,6.443,4.355a7.4,7.4,0,0,1-4.539,1.236q-5.693,0-6.776-1.155m-4.275-19.895q-2.137,2.594-2.137,12.379,0,8.407,2.249,10.788t10.17,2.38q7.232,0,9.805-2.613l2.633,1.823,2.168-3.16-2.9-1.985a42.913,42.913,0,0,0,.547-8.509q0-8.812-2.2-11.254t-10.14-2.441q-8.064,0-10.2,2.593",
    transform: "translate(-295.6 -1094.081)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M333.79,903.306a38.232,38.232,0,0,1,37.237,46.7c-4.427-1.228-8.719-2.707-12.72-4.218a24.888,24.888,0,1,0-12.544,17.531,25.045,25.045,0,0,0,4.427-3.115c.223.171.45.343.677.51,3.356,2.531,6.721,5.1,10.309,7.305.014.009.032.018.046.028a38.674,38.674,0,0,1-3.769,3.416,38.189,38.189,0,1,1-23.664-68.16Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M358.307,945.79a24.888,24.888,0,1,0-12.544,17.531,25.045,25.045,0,0,0,4.427-3.115c.223.171.45.343.677.51,3.356,2.531,6.721,5.1,10.309,7.305.014.009.032.018.046.028a38.674,38.674,0,0,1-3.769,3.416A38.189,38.189,0,1,1,371.977,941.5a38.436,38.436,0,0,1-.95,8.511C366.6,948.78,362.307,947.3,358.307,945.79Z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(315.248 944.134)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M372.136,997.379c-23.295-9.548-34.148.214-34.148.214,15.609-4.371,25.569,2.8,35.62,10.374,3.355,2.529,6.721,5.1,10.31,7.306,5.672,3.485,11.9,6.048,19.535,6.053,31.334.02,35.035-29.943,35.035-29.943-15.381,24.593-46.727,14.041-66.352,6",
    transform: "translate(-337.988 -991.383)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(329.393 918.495)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M369.383,940.473a2.7,2.7,0,0,0,0,3.985c2.778,3.03,3.566,4.151,3.442,5.355,0,0,4.114-3.695,4.695-4.193a2.255,2.255,0,0,0,.249-3.653,32.823,32.823,0,0,1-3.325-3.695,2.784,2.784,0,0,1-.623-2.2s-3.608,3.487-4.438,4.4",
    transform: "translate(-368.503 -936.073)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(329.393 931.198)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M369.383,967.876a2.7,2.7,0,0,0,0,3.985c2.778,3.031,3.566,4.151,3.442,5.355,0,0,4.114-3.694,4.695-4.193a2.255,2.255,0,0,0,.249-3.653,32.848,32.848,0,0,1-3.325-3.694,2.785,2.785,0,0,1-.623-2.2s-3.608,3.487-4.438,4.4",
    transform: "translate(-368.503 -963.476)",
    fill: "url(#linear-gradient)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginPageLogo);
export default __webpack_public_path__ + "static/media/login-page-logo.24a3b79a8ab5b44713cc73cfc1b13795.svg";
export { ForwardRef as ReactComponent };